import { render, staticRenderFns } from "./_Tag.vue?vue&type=template&id=b334efea&"
import script from "./_Tag.vue?vue&type=script&lang=js&"
export * from "./_Tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports